import React from 'react';
import { Pie, G2 } from '@ant-design/charts';
import { Typography } from 'antd';
import PageTopWrapper from './page-top-wrapper';

interface IProps {
    dataReport: any;
}
const NotePie: React.FC<IProps> = ({ dataReport = {} }) => {
    const { registerTheme } = G2;
    registerTheme('custom-theme', {
        colors10: ['#FACDAA', '#F4A49E', '#EE7B91', '#E85285'],
        colors20: ['#FACDAA', '#F4A49E', '#EE7B91', '#E85285', '#BE408C'],
    });
    const config = {
        data: dataReport?.listQuaDem || [],
        angleField: 'total',
        colorField: 'name',
        radius: 0.85,
        label: {},
        interactions: [{ type: 'element-active' }],
        theme: 'custom-theme',
    };
    return (
        <div>
            <PageTopWrapper leftContent={<Typography.Title level={5}>Khách qua đêm</Typography.Title>} />
            <Pie {...config} className="chart-status" />
        </div>
    );
};

export default NotePie;
